import JsBarcode from 'jsbarcode';
import PropTypes from 'prop-types';
import React from 'react';

class Barcode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    barcode: PropTypes.string,
  };

  componentDidMount() {
    JsBarcode('#barcode', this.props.barcode, {
      format: this.props.barcode.length === 13 ? 'EAN13' : 'EAN8',
    });
  }

  render() {
    return <canvas id="barcode" />;
  }
}

export default Barcode;
